import React, {Component} from 'react';
import YouTube from 'react-youtube';

  class Videos extends Component {

    constructor(props) {
      super(props);
      this.state = {
        YtData: {
          items: []
        },
        YtParamsPage: 1,
        YtParamsItemsOnPage: 5,
        YtParamsPages: 0

      };
    }


    componentDidMount() {
      fetch('https://www.googleapis.com/youtube/v3/playlistItems?part=snippet%2CcontentDetails&maxResults=50&playlistId=PLY30wkZlrHKR_gW0mMklk_NPWA4-aDUf9&key=AIzaSyADO6BXZB1UpkoIJVp_Xx8oEiZj9ZZEY10').then(res => res.json()).then(json => {
        this.setState({
          YtData: json,
          YtParamsPages: Math.ceil(json.items.length / this.state.YtParamsItemsOnPage)


        });
      });
      
    }
    
    clickPagination = (page) => {
      this.setState({YtParamsPage: page});
      //console.log(this.props.store);
      //window.scrollTo(0, this.props.store.getState())
    }
// https://www.googleapis.com/youtube/v3/playlistItems?part=snippet%2CcontentDetails&maxResults=25&playlistId=PLMRYn3pnaTARbxt6MUR8gr42Mhtey8rBJ&key=AIzaSyADO6BXZB1UpkoIJVp_Xx8oEiZj9ZZEY10

//<div onClick={() => this.setState({YtParamsPage: i})}>i</div>
    render() {

      const opts = {
        height: '410px',
        width: '100%',
        playerVars: { // https://developers.google.com/youtube/player_parameters
          autoplay: 0,
          controls: 0,
          showinfo: 0,
          modestbranding: 0
        }
      };

      const listItems = this.state.YtData.items.slice((this.state.YtParamsPage * this.state.YtParamsItemsOnPage - this.state.YtParamsItemsOnPage), (this.state.YtParamsPage * this.state.YtParamsItemsOnPage)).map((item, index) =>



      <div className="videoList" key={index}>
          <h3>{item.snippet.title}</h3>
          <p>{item.snippet.description.substring(0, 200)} ...</p>
        <YouTube videoId={item.snippet.resourceId.videoId} opts={opts} onReady={this._onReady} onPlay={this._onPlay} onPause={this._onStop} onEnd={this._onStop}/>
        </div>
    );
    if(this.state.YtParamsPages > 1) {
    var pagination = [];
    if(this.state.YtParamsPage === 1) {
        pagination[0] = <div className="ytPagination firstPagination" onClick={() => this.clickPagination(1)} key={0}>Previous</div>;

    } else {
      let pg = (this.state.YtParamsPage-1);
        pagination[0] = <div className="ytPagination firstPagination" onClick={() => this.clickPagination(pg)} key={0}>Previous</div>;
      }
      for (let i = 1; i <= this.state.YtParamsPages; i++) {
        if(this.state.YtParamsPage === i) {
          pagination[i] = <div className="ytPagination paginationActive"  onClick={() => this.clickPagination(i)} key={i}>{i}</div>;
        } else {
          pagination[i] = <div className="ytPagination"  onClick={() => this.clickPagination(i)} key={i}>{i}</div>;


      }
      }
      if(this.state.YtParamsPage === this.state.YtParamsPages) {
          pagination[pagination.length + 1] = <div className="ytPagination lastPagination"  onClick={() => this.clickPagination(this.state.YtParamsPages)} key={pagination.length + 1}>Next</div>;

    } else {
        let pg = (this.state.YtParamsPage+1);
          pagination[pagination.length + 1] = <div className="ytPagination lastPagination"  onClick={() => this.clickPagination(pg)} key={pagination.length + 1}>Next</div>;
      }
}

      return (
        <section>
        <div className="Wrapper">
          <div className="Content">
            <h2>Videos</h2>
              <div className="ytPaginationWrapper">{pagination}</div>
              {listItems}
              <div className="ytPaginationWrapper">{pagination}</div>

        </div>
        </div>
      </section>
      );
    }

  }

  export default Videos;



// WEBPACK FOOTER //
// ./src/pages/Videos.js